var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout--full-page"},[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }